import { render, staticRenderFns } from "./AIGeneratedBadge.vue?vue&type=template&id=467717cc"
import script from "./AIGeneratedBadge.vue?vue&type=script&lang=js"
export * from "./AIGeneratedBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports